import { createFileRoute } from '@tanstack/react-router'
import { OutboundWebhooks } from '@/components/webhooks/OutboundWebhooks'

export const Route = createFileRoute('/_app/webhooks/outbound')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold tracking-tight">Webhooks Enviados</h2>
      </div>
      <OutboundWebhooks />
    </div>
  )
}
